import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { EmployeeScheduleEditScheduleTypesScreen } from "./EmployeeScheduleEditScheduleTypesScreen";
import { EmployeeScheduleEditScheduleTypesAssignTeamScreen } from "./EmployeeScheduleEditScheduleTypesAssignTeam";

import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { useIntl } from "react-intl";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";

export type EmployeeScheduleStackParamList = {
  EmployeeScheduleEditScheduleTypes: object;
  EmployeeScheduleEditScheduleTypesAssignTeam: {
    teamId: string;
    teamName: string;
  };
};
const Stack = createNativeStackNavigator<EmployeeScheduleStackParamList>();

export const EmployeeScheduleEdit = withWebModal(EmployeeScheduleEditC);
function EmployeeScheduleEditC(
  props: UserLoggedInNavigatorScreenProps<"EmployeeScheduleEdit">
) {
  const intl = useIntl();

  const getOptions = useNavigationHeaderOptions();
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="EmployeeScheduleEditScheduleTypes"
        component={EmployeeScheduleEditScheduleTypesScreen}
        options={({ navigation }) =>
          getOptions({
            type: "CLOSE",
            onClose() {
              navigation.goBack();
            },
            headerTitle: intl.formatMessage({
              defaultMessage: "Assign Cost Centers",
              description: "Title for EmployeeScheduleEditScheduleTypesScreen", // "Tilldela Kostnadsställen"
            }),
            defaultContentStyle: true,
          })
        }
      />
      <Stack.Screen
        name="EmployeeScheduleEditScheduleTypesAssignTeam"
        component={EmployeeScheduleEditScheduleTypesAssignTeamScreen}
        options={({ navigation, route }) =>
          getOptions({
            type: "SAVE-INIT",
            onCancel() {
              navigation.goBack();
            },
            headerTitle: route.params.teamName,
            defaultContentStyle: true,
          })
        }
      />
    </Stack.Navigator>
  );
}
